export default "__VITE_ASSET__CMudImEV__"